import fetch from 'isomorphic-unfetch'

export const getAPIService = async (url, header, language) => {
  const urlCall = `${url}`
  const headers = buildHeader(header, language)
  const res = await fetch(urlCall, {
    method: 'GET',
    headers,
  })
    .then(response => {
      return response.json()
    })
    .then(json => {
      if (json.code === 0) return { status: true, message: json.message }
      else return { status: false, message: json.message, errorCode: json.code }
    })
    .catch(ex => {
      return { status: false, message: ex, errorCode: 500 }
    })
  return res
}

export const postAPIService = async (url, header, body, language) => {
  const headers = buildHeader(header, language)
  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: body,
  })
    .then(response => {
      return response.json()
    })
    .then(json => {
      if (json.code === 0) return { status: true, message: json.message }
      else return { status: false, message: json.message, errorCode: json.code }
    })
    .catch(ex => {
      console.error('catch', ex)
      return { status: false, message: ex, errorCode: 500 }
    })
  return res
}

export const putAPIService = async (url, header, body, language) => {
  const headers = buildHeader(header, language)
  const res = await fetch(url, {
    method: 'PUT',
    headers,
    body: body,
  })
    .then(response => {
      return response.json()
    })
    .then(json => {
      if (json.code === 0) return { status: true, message: json.message }
      else return { status: false, message: json.message, errorCode: json.code }
    })
    .catch(ex => {
      return { status: false, message: ex, errorCode: 500 }
    })
  return res
}

export const delAPIService = async (url, header, body, language) => {
  const headers = buildHeader(header, language)
  const res = await fetch(url, {
    method: 'DELETE',
    headers,
    body: body,
  })
    .then(response => {
      return response.json()
    })
    .then(json => {
      if (json.code === 0) return { status: true, message: json.message }
      else return { status: false, message: json.message, errorCode: json.code }
    })
    .catch(ex => {
      return { status: false, message: ex, errorCode: 500 }
    })
  return res
}

export const uploadFile = async (url, header, language, files) => {
  const headers = buildHeader(header, language)
  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: files,
  })
    .then(response => {
      return response.json()
    })
    .then(json => {
      if (json.code === 0) return { status: true, message: json }
      else return { status: false, message: json, errorCode: json.code }
    })
    .catch(ex => {
      return { status: false, message: ex, errorCode: 500 }
    })
  return res
}

export const getSignedUrlForS3 = async (url, header, language) => {
  const urlCall = `${url}`
  const headers = buildHeader(header, language)
  const res = await fetch(urlCall, {
    method: 'GET',
    headers,
  })
    .then(response => {
      return response.json()
    })
    .then(json => {
      if (json.code === 0) return { status: true, message: json.message }
      else return { status: false, message: json.message, errorCode: json.code }
    })
    .catch(ex => {
      return { status: false, message: ex, errorCode: 500 }
    })
  return res
}

export const uploadFileSignedUrlToS3 = async (header, url, language, files) => {
  const res = await fetch(url, {
    method: 'PUT',
    headers: { 'x-amz-acl': 'public-read', 'Content-Type': files.value[0].type },
    body: files.value[0],
  })
    .then(response => {
      if (response.status === 0) return { status: true, message: files }
      else return { status: false, message: files, errorCode: 10000 }
    })
    .catch(ex => {
      return { status: false, message: ex, errorCode: 500 }
    })
  return res
}

export const buildHeader = (header, language) => {
  const result = {
    ...header,
    ...setHeaderContentLanguage(language),
  }
  return result
}
export const buildHeaderForUploadFiles = header => {
  const result = {
    ...header,
    'Content-Type': 'multipart/form-data',
  }
  return result
}

export const setHeaderContentLanguage = language => {
  const lang = setContentLanguage(language)
  return {
    'Content-Language': lang,
    'Accept-Language': lang,
  }
}
export const setContentLanguage = language => {
  let result = 'en-us'
  switch (language) {
    case 'th':
      result = 'th'
      break
    case 'en-us':
      result = 'en-us'
      break
    case 'my':
      result = 'my'
      break
    case 'zh_cn':
      result = 'ch'
      break
    default:
      result = 'en-us'
  }
  return result
}
